import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage.js";
import Estoque from "./pages/Estoque.js";
import Financiamento from "./pages/Financiamento.js";
import Venda from "./pages/Venda.js";
import Contato from "./pages/Contato.js";
import VeiculoClient from "./pages/Veiculo.js";
import WhatsappFloatButton from "./components/WhatsappFloatButton.js";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/estoque" element={<Estoque /> } />
          <Route path="/financiamento" element={<Financiamento />} />
          <Route path="/venda" element={<Venda />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/veiculo/:idVeiculo" element={<VeiculoClient />}/>
        </Routes>
        <WhatsappFloatButton />
      </BrowserRouter>
    </div>
  );
}

export default App;